<div *ngIf="!docExists; else warning">
    <h2 mat-dialog-title i18n="my documents upload document modal title@@my-documents-upload-document-modal-title">Uploading file</h2>
    <mat-dialog-content class="content-message mb-4">
        <span *ngIf="uploading && !error; else uploadingComplete" span i18n="my documents uploading document message@@my-documents-uploading-document">The file is being uploaded to your OneDrive.</span>
        <ng-template #uploadingComplete>
            <ng-container i18n="my documents upload document complete message@@my-documents-upload-document-completed-message">The file was uploaded successfully. Click </ng-container>
            <app-action-link [href]="fileUrl" [target]="'_blank'" i18n="text@@here">here</app-action-link>
            <ng-container i18n="my documents upload document complete message suffix@@my-documents-upload-document-completed-message-suffix"> to open.</ng-container>
        </ng-template>
    </mat-dialog-content>
    <mat-progress-bar mode="indeterminate" *ngIf="uploading"></mat-progress-bar>
    <p class="mt-2" *ngIf="error" i18n="my documents upload error msg@@my-documents-upload-error-msg">Could not upload the document due to network issue. Please try again later.</p>
    <mat-dialog-actions *ngIf="error" align="end">
        <button mat-button mat-dialog-close color="accent" (click)="cancelUpload()" i18n="cancel text@@cancel-text">Cancel</button>
    </mat-dialog-actions>
    <mat-dialog-actions align="end" *ngIf="!uploading">
        <button mat-button mat-dialog-close color="accent" (click)="cancelUpload()" i18n="close text@@close-text">Close</button>
    </mat-dialog-actions>
</div>

<ng-template #warning>
    <h2 mat-dialog-title i18n="my documents upload document modal title@@my-documents-upload-document-modal-title">Uploading file</h2>
    <mat-dialog-content class="content-message mb-4">
        <span i18n="my documents uploading document warning message@@my-documents-uploading-document-warning">A file with this name already exists. Would you like to replace the existing one?</span>
    </mat-dialog-content>


    <mat-dialog-actions align="end">
        <button mat-flat-button color="accent" class="mr-3 primary-contrast-color" (click)="replaceDoc()" i18n="replace text@@replace-text">Replace</button>
        <button mat-button mat-dialog-close color="accent" (click)="cancelUpload()" i18n="close text@@close-text">Close</button>
    </mat-dialog-actions>
</ng-template>
